<template>
    <div>
        <!-- 首页轮播图 -->
        <iristar-carousel></iristar-carousel>
        <!-- 行业服务 -->
        <iristar-dividing>
            <router-link to="/iristar-solution"> {{ $t("programme.title") }} </router-link>
        </iristar-dividing>
        <iristar-programme></iristar-programme>

        <iristar-dividing>
            <router-link to="/iristar-product-center"> {{ $t("title.title1") }} </router-link>
        </iristar-dividing>

        <el-row class="text-center c-g-d main-box mh-a">
            <el-col :span="8" v-for="(proItem, proIndex) in productData" :key="`${proIndex}_pro`"
                @click.native="$router.push({ name: proItem.path })" class="c-pointer mobil-pro">
                <h3 class="mb14 fw-s fs24">
                    {{ $t(`${proItem.title}.title`) }}
                </h3>
                <div class="w370px h250px mh-a iristar-product ovh border-r mobil-pro">
                    <el-image class="h-total w-total transtion" :src="proItem.img" fit="cover"></el-image>
                </div>
            </el-col>
        </el-row>

        <iristar-dividing>
            <router-link to="/iristar-core">{{ $t("HOME_NAV.core") }} </router-link>
        </iristar-dividing>
        <el-image src="./static/img/core.png" fit="contain" class="c-pointer main-box mh-a d-b"
            @click="$router.push({ name: 'iristarCore' })"></el-image>

        <iristar-dividing>
            <router-link to="/iristar-news">{{ $t("HOME_NAV.news") }} </router-link>
        </iristar-dividing>
        <iristar-news></iristar-news>
        <!-- 合作伙伴 -->
        <iristar-partner></iristar-partner>
    </div>
</template>

<script>
import IristarCarousel from "@/components/IristarCarousel";
import IristarDividing from "@/components/IristarDividing";
import IristarProgramme from "@/components/IristarProgramme";
import IristarNews from "@/components/IristarNews";
import IristarPartner from "@/components/IristarPartner";
export default {
    name: "HomeInfo",
    data() {
        return {
            productData: [
                {
                    title: "software",
                    img: "/static/img/programme/programme1.png",
                    path: "iristarSoftware",
                },
                {
                    title: "aiservice",
                    img: "/static/img/programme/programme2.png",
                    path: "iristarSoftware",
                },
                {
                    title: "hardware",
                    img: "/static/img/programme/programme3.png",
                    path: "iristarProduct",
                },

            ],
        };
    },
    components: {
        IristarCarousel,
        IristarDividing,
        IristarProgramme,
        IristarNews,
        IristarPartner,
    },
};
</script>

<style></style>